__webpack_require__.p = "/collioure/";